var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "align-landscape 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "car 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 432528198_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29 5H11C9.34315 5 8 6.67893 8 8.75V31.25C8 33.3211 9.34315 35 11 35H29C30.6569 35 32 33.3211 32 31.25V8.75C32 6.67893 30.6569 5 29 5Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 27H27",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 23H19",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13 11L13 15C13 15.5523 13.4477 16 14 16L18 16C18.5523 16 19 15.5523 19 15L19 11C19 10.4477 18.5523 10 18 10L14 10C13.4477 10 13 10.4477 13 11Z",
    stroke: "#5F738C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/id_card.ed0b96284d4f5e03943fa0fb087d6362.svg";
export { ForwardRef as ReactComponent };